'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './complete_streets.routes';

export class CompleteStreetsComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $timeout, $http, baseConfigService, $stateParams) {
    const vm = this;
    this.$scope = $scope;
    this.fetch = fetch;
    this.lookup = lookup;
    this.userService = userService;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$http = $http;
    this.baseConfigService = baseConfigService;

    $scope.adminUnlocked = false; // track admin manual unlock
    $scope.submissions = [];
    $scope.stationaccess = {};
    $scope.attachmentData = $scope.attachmentData || {};
    $scope.savemode = null;

    $scope.initialLoad = true;

    $scope.baseUrl = baseConfigService.getBaseURL();
    $scope.completeStreetsCheck = false;

    $scope.submitmode = null;

    // Initialize form and state variables
    // $scope.currentStationPolicy = {};
    $scope.type = 'Complete Streets';

    $scope.pendingChanges = false;
    $scope.showPanel = null;

    $scope.togglePanel = function (panelName) {
      $scope.showPanel = panelName;
    };

    $scope.setPending = function () {
      console.log('set pending ran')
      console.log($scope.initialLoad);
      if (!$scope.initialLoad) {
        $scope.savemode = 'stationaccess';
        $scope.pendingChanges = true;
      }
    }

    $scope.isFormEditable = function () {
      if (!$scope.currentStationPolicy) return true;

      var role = $scope.currentUser && $scope.currentUser.role;

      // Find matching submission status for current policy
      var submission = null;
      if ($scope.stationAccessStatus) {
        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
            submission = $scope.stationAccessStatus[i];
            break;
          }
        }
      }

      // Not yet submitted — allow editing
      if (!submission || !submission.submitted) return true;


      // Admins can edit if they've manually unlocked
      if (role === 'Administrator') {
        return $scope.adminUnlocked;
      }

      // Admin set it to "Needs Work" — allow editing without withdraw
      if (submission.status === 'Needs Work') return true;

      // Otherwise submitted and locked — user must withdraw to edit
      return false;
    };

    $scope.$watch(
      function () {
        return $scope.currentStationPolicy
      },
      function () {
        $scope.adminUnlocked = false;
        $scope.formReadOnly = !$scope.isFormEditable();
        $scope.withdrawnNotice = false;
        $scope.needsWorkNotice = false;
        if ($scope.stationAccessStatus && $scope.currentStationPolicy && $scope.currentStationPolicy.policy_name) {
          var sub = _.find($scope.stationAccessStatus, { submission_policy_name: $scope.currentStationPolicy.policy_name });
          if (sub && sub.submitted && sub.status === 'Needs Work') { $scope.needsWorkNotice = true; }
        }
      }
    );

    $scope.$watch('stationAccessStatus', function () {
      if (!$scope.currentStationPolicy) return;
      $scope.formReadOnly = !$scope.isFormEditable();
    }, true);

    $scope.toggleAdminUnlock = function () {
      $scope.adminUnlocked = !$scope.adminUnlocked;
      $scope.formReadOnly = !$scope.isFormEditable();
    };

    $scope.withdrawSubmission = function () {
      var confirmWithdraw = window.confirm(
        'Are you sure you want to withdraw this submission? You will need to complete the Review and Submit process again after making changes.'
      );
      if (!confirmWithdraw) return;

      var submission = null;
      if ($scope.stationAccessStatus) {
        for (var i = 0; i < $scope.stationAccessStatus.length; i++) {
          if ($scope.stationAccessStatus[i].submission_policy_name === $scope.currentStationPolicy.policy_name) {
            submission = $scope.stationAccessStatus[i];
            break;
          }
        }
      }

      if (!submission || !submission.submission_id) {
        console.error('No matching submission found to withdraw');
        return;
      }

      var payload = {
        submission_id: submission.submission_id,
        submitted: false,
        status: null
      };

      fetch.updateItem('api/data/submissions/update-status', payload)
        .then(function () {

          submission.submitted = false;
          submission.status = null;

          // Clear form fields — preserve only identity fields
          var formId = $scope.currentStationPolicy ? $scope.currentStationPolicy.stationaccess_form_id : null;
          var policyName = $scope.currentStationPolicy ? $scope.currentStationPolicy.policy_name : null;
          $scope.currentStationPolicy = { stationaccess_form_id: formId, policy_name: policyName };

          // Show withdrawn notification
          $scope.withdrawnNotice = true;
          $scope.needsWorkNotice = false;
          $scope.success = false;

          $scope.formReadOnly = false;
        })
        .catch(function (err) {
          console.error('Withdraw failed:', err);
          alert('There was an error withdrawing the submission. Please try again.');
        });
    };

    $scope.addToSubmissions = function (submission) {
      const index = $scope.submissions.indexOf(submission);
      if (index > -1) { // only splice array when item is found
        $scope.submissions.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        $scope.submissions.push(submission);
      }


      if ($scope.submissions.length > 0) {
        $scope.submitmode = 'stationaccess';
      } else {
        $scope.submitmode = null;
      }
    }

    $scope.getSubmissionStatus = function () {
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Station Area Access')
        .then(response => {
          $scope.stationAccessStatus = response.data;
          console.log('Station Access status response:', response.data);
          $scope.checkParking1 = (_.filter(response.data, { submission_policy_name: 'Complete Streets Policy' }))[0];
          // $scope.checkParking2 = (_.filter(response.data, { submission_policy_name: 'Project Prioritization' }))[0];
          console.log('Loaded policy submissions:', $scope.stationAccessStatus);

          $scope.completeStreetsCheck = !!(_.filter(response.data, { 
            submission_policy_name: 'Complete Streets Policy', submitted: true
          }))[0];

      if ($scope.stationaccess) {
        $scope.stationaccess.completeStreetsCheck = $scope.completeStreetsCheck;
        }

      $scope.formReadOnly = !$scope.isFormEditable();
        })
        .catch(err => {
          console.log(err);
        })
    }

    $scope.updateSubmissionStatus = function (row, newStatus) {

      if (!row || !row.submission_id) {
        console.error('submission_id is missing:', row);
        return;
      }

      const originalStatus = row.status;

      // Update the UI immediately
      row.status = newStatus;

      const updateData = {
        submission_id: row.submission_id,
        status: newStatus
      };

      console.log('Updating submission:', {
        id: row.submission_id,
        status: newStatus
      });

      fetch.updateItem('api/data/submissions/update-status', updateData)
        .then(response => {
          $timeout(() => {
            $scope.successMessage = 'Status updated successfully';
          });
        })
        .catch(err => {
          console.error('Error updating status:', err);
          $timeout(() => {
            // Revert the status if update failed
            row.status = originalStatus;
            $scope.error = 'Failed to update status';
          });
        });
    };



    $scope.getStationbyID = function (station) {
      if (station) {
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
      }
      vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
      $scope.getSubmissionStatus()
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Station Area Access')
        .then(response => {
          console.log(response)

          $scope.currentStation = response.data[0];

          $scope.stationCompleteStreets = _.filter(response.data, { 'submission_policy_name': 'Complete Streets Policy' });
          if ($scope.stationCompleteStreets.length > 0) {
            console.log($scope.stationCompleteStreets)
            $scope.stationCompleteStreets.forEach(element => {
              console.log(element.submitted, "element submitted")
              if (element.submitted && element.submitted === true) {
                $scope.completeStreetsCheck = true;
              }
            });
          }
          $scope.stationGapAnalysis = _.filter(response.data, { 'submission_policy_name': 'Gap Analysis' });
          if ($scope.stationGapAnalysis.length > 0) {
            $scope.stationGapAnalysis.forEach(element => {
              if (element.submitted && element.submitted === true) {
                $scope.stationGapAnalysisCheck = true;
              }
            });
          }
          $scope.stationProjectPrioritization = _.filter(response.data, { 'submission_policy_name': 'Project Prioritization' });
          if ($scope.stationProjectPrioritization.length > 0) {
            $scope.stationProjectPrioritization.forEach(element => {
              if (element.submitted && element.submitted === true) {
                $scope.projectCheck = true;
              }
            });
          }
          $scope.stationMobilityHubPlanning = _.filter(response.data, { 'submission_policy_name': 'Mobility Hub Planning' });
          if ($scope.stationMobilityHubPlanning.length > 0) {
            $scope.stationMobilityHubPlanning.forEach(element => {
              if (element.submitted && element.submitted === true) {
                $scope.mobilityCheck = true;
              }
            });
          }

          // Check if a specific policy was requested via policyName parameter
          const requestedPolicyName = $stateParams.policyName;
          if (requestedPolicyName) {
            $scope.type = requestedPolicyName;
            // console.log('Setting policy from policyName parameter:', requestedPolicyName);

            // Activate the correct tab based on the policy name
            $timeout(() => {
              let targetTab;
              if (requestedPolicyName === 'Complete Streets Policy') {
                targetTab = '#section-1';
              } else if (requestedPolicyName === 'Project Prioritization') {
                targetTab = '#section-2';
              }

              if (targetTab) {
                // Remove active class from all tabs
                document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
                  tab.classList.remove('active');
                });
                document.querySelectorAll('.tab-pane').forEach(pane => {
                  pane.classList.remove('show', 'active');
                });

                // Activate the target tab
                const tabTrigger = document.querySelector(`[data-bs-target="${targetTab}"]`);
                if (tabTrigger) {
                  tabTrigger.classList.add('active');
                  const tabPane = document.querySelector(targetTab);
                  if (tabPane) {
                    tabPane.classList.add('show', 'active');
                  }
                }
                // console.log('Activated tab:', targetTab);
              }
            }, 100);
          }

          return $scope.getCurrentStationPolicy($scope.type);

        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }



    /**
* Update station area dropdown based on jurisdiction selected
* @param {*} jurisdiction 
*/
    $scope.getStationAreaList = function (jurisdiction) {
      // Check for sta_recid parameter from $stateParams
      const staRecId = $stateParams.sta_recid;

      lookup.setJurisdiction(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {

          $scope.stationAreas = response.data;

          // Set currentSelectedStationId based on sta_recid
          if (staRecId) {
            $scope.currentSelectedStationId = staRecId;
          } else if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation();
          }

          // Call getStationbyID() after setting currentSelectedStationId
          if ($scope.currentSelectedStationId) {
            $scope.getStationbyID($scope.currentSelectedStationId);
          }
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.getCurrentStationPolicy = function (type) {
      if (type) {
        $scope.type = type;
      }
      fetch.getAllItems(`api/data/getAccessForm/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}/${encodeURIComponent($scope.type)}`)
        .then(response => {

          console.log(response);

          $scope.currentStationPolicy = response.data[0];

          console.log('stationaccess_form_id:', $scope.currentStationPolicy.stationaccess_form_id);
          if (type === 'Project Prioritization') {
            if ($scope.currentStationPolicy.capital_improvement_program) {
              $scope.capital_improvement_program_checked = true;
            }
            if ($scope.currentStationPolicy.projects_submitted_funded) {
              $scope.projects_submitted_funded_checked = true;
            }
            if ($scope.currentStationPolicy.other_fund_implementation) {
              $scope.other_fund_implementation_checked = true;
            }
          }
          $scope.initialLoad = false;
          console.log($scope.initialLoad);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })

    }


    $scope.updateCurrentStationPolicy = function () {
      console.log($scope.currentStationPolicy)

      $scope.formSubmitted = true;
      if (stationAccessForm.$invalid) {
        $scope.saving = false;
        return;
      }

      // Ensure jurisdiction, sta_recid, and type are included in the payload
      $scope.currentStationPolicy.jurisdiction = $scope.currentJurisdiction;
      $scope.currentStationPolicy.sta_recid = $scope.currentSelectedStationId;
      $scope.currentStationPolicy.type = $scope.type;

      if (!$scope.currentStationPolicy.stationaccess_form_id) {
        console.error('stationaccess_form_id is missing');
        return;
      }

      console.log('Payload being sent:', $scope.currentStationPolicy);

      fetch.updateItem(`api/data/access/forms/update`, $scope.currentStationPolicy)
        .then(response => {

          $scope.saved = true;
          $scope.saving = false;
          setTimeout(() => {
            // $scope.submitmode = null;
            $scope.saved = false;
            $scope.savemode = null;
            $scope.$apply();
          }, 4000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    $scope.submitStationAccess = function () {
      console.log($scope.stationaccess.completeStreetsCheck);
      $scope.formSubmitted = true;
      $scope.saving = true;
      var upsertData = []; // Initialize upsertData array

      $scope.upsertData = []; // Reset or initialize upsert data array

      console.log("submissing", $scope.stationaccess.completeStreetsCheck, $scope.stationCompleteStreets.length)
      if ($scope.stationaccess.completeStreetsCheck && $scope.stationCompleteStreets.length > 0) {
        $scope.stationCompleteStreets.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              station_access_complete_streets: true,
              submitted: true,
            })
          }
        });
      }

      console.log(upsertData);

      if ($scope.stationaccess.projectCheck && $scope.stationProjectPrioritization.length > 0) {
        $scope.stationProjectPrioritization.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              station_access_project_prioritization: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.stationaccess.stationGapAnalysisCheck && $scope.stationGapAnalysis.length > 0) {
        $scope.stationGapAnalysis.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              station_access_gap_analysis: true,
              submitted: true,
            })
          }
        });
      }

      if ($scope.stationaccess.mobilityCheck && $scope.stationMobilityHubPlanning.length > 0) {
        $scope.stationMobilityHubPlanning.forEach(element => {
          if (!element.submitted) {
            element.submitted = true;
            upsertData.push({
              submission_id: element.submission_id,
              station_access_mobility_hub_planning: true,
              submitted: true,
            })
          }
        });
      }

      // Add submission data to upsertData
      // $scope.upsertData.push($scope.currentStationPolicy);



      // $scope.upsertData = _.union($scope.stationCompleteStreets, $scope.stationProjectPrioritization, $scope.stationGapAnalysis, $scope.stationMobilityHubPlanning);

      fetch.updateItem('api/data/submissions/update', upsertData)
        .then(response => {

          $scope.saving = false;
          $scope.submissions = [];
          $scope.saved = true;
          $scope.pendingChanges = false;
          setTimeout(() => {
            $scope.submitmode = null;
            $scope.saved = false;
            $scope.$apply();
          }, 2000);
        })
        .catch(err => {
          console.log(err);
          if (err.status === 403) {
            $state.go('login');
          }
        })
    }

    // File upload functions 

    $scope.initializeField = function (fieldId) {
      if (!$scope.attachmentData[fieldId]) {
        $scope.attachmentData[fieldId] = {
          fileName: null,
          file: null,
          isFileSelected: false
        };
      }
    };

    // Function to open the file dialog
    $scope.openFileDialog = function (fieldId) {
      $timeout(function () {
        document.getElementById('fileInput' + fieldId).click();
      }, 0);
    };

    // Function to handle file changes
    $scope.fileChanged = function (fieldId, element) {
      $scope.initializeField(fieldId);  // Ensure field is initialized

      var file = element.files[0];
      if (file) {
        // Check if the file type is PDF, Word document, or Excel file
        if (
          file.type !== 'application/pdf' &&
          file.type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && // For .docx
          file.type !== 'application/msword' && // For .doc
          file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && // For .xlsx
          file.type !== 'application/vnd.ms-excel' // For .xls
        ) {
          alert('Please select a PDF, Word document, or Excel file.');
          element.value = ''; // Reset input to clear the wrong file type
          return;
        }

        $scope.attachmentData[fieldId].fileName = file.name;
        $scope.attachmentData[fieldId].file = file;
        $scope.attachmentData[fieldId].isFileSelected = true;

        $scope.$apply();
      }
    };

    $scope.clearFile = function (ngmodel) {
      console.log(ngmodel);
      var fileInput = document.getElementById(`${ngmodel}`);
      console.log(fileInput);
      if (fileInput) {
        fileInput.value = ''; // clears the file input
        // Clear any associated model/preview values
        $scope[ngmodel] = '';
        $scope[`${ngmodel}_preview`] = '';
        $scope[`fileUploading_${ngmodel}`] = false;

        // If there's a form control, reset its validation state
        if ($scope.form && $scope.form[ngmodel]) {
          $scope.form[ngmodel].$setPristine();
          $scope.form[ngmodel].$setUntouched();
        }
      }
    };

    $scope.uploadFile = function (ngmodelfile) {
      var ngmodel = ngmodelfile.substring(0, ngmodelfile.length - 10);
      console.log(ngmodel);
      $scope[`fileUploading_${ngmodelfile}`] = true;
      var file = document.getElementById(`${ngmodelfile}`).files[0];

      if (!file) {
        console.error('No file selected');
        return;
      }

      var fileUpload = {
        fileName: file.name,
        fileType: file.type
      };

      // Using POST to get the signed URL and public URL
      fetch.updateItem('api/data/get-signed-url', fileUpload)
        .then(response => {
          console.log('Signed URL:', response.data.signedUrl);
          console.log('Public URL:', response.data.publicUrl);

          // Use the signed URL to upload the file
          return $http({
            method: 'PUT',
            url: response.data.signedUrl,
            data: file,
            headers: {
              'Content-Type': file.type,
              // 'x-amz-acl': 'public-read' // Ensure the file is publicly readable
            }
          })
            .then(() => {
              // After successful upload, store the public URL in the scope
              $scope.currentStationPolicy[ngmodel] = response.data.publicUrl;
              return response.data.publicUrl; // Return the public URL for further use
            });
        })
        .then(publicUrl => {
          console.log('Upload successful');
          console.log('Public URL:', publicUrl);

          // Update UI state
          $scope[`fileUploading_${ngmodelfile}`] = false;
          $scope[`${ngmodelfile}`] = '';
          $scope.clearFile(ngmodelfile);
          $scope.uploadSuccess = true;
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Upload failed');
        });
    };

    $scope.checkSubstring = function (input) {
      return input && input.length >= 4 && input.substring(0, 4) === 'http';
    };

    $scope.removeFile = function (ngmodel) {
      console.log(ngmodel);
      $scope.currentStationPolicy[ngmodel] = '';
      $scope.setPending();
      $scope.savemode = 'stationaccess';
      $scope.pendingChanges = true;
    };


    // End file upload functions 

  }

  $onInit() {
    this.userService.getCurrentUser()
      .then(response => {

        this.$scope.currentUser = response.data;
        this.userService.setCurrentUser(response.data);
        this.$scope.currentStationPolicy = {};
        this.getJurisdictionList();
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          this.$state.go('login');
        }
      })
  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
          if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
          this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);

          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Consistent' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Consistent' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Consistent' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Consistent' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }


}

export default angular.module('appApp.complete_streets', [uiRouter])
  .config(routes)
  .component('completeStreets', {
    template: require('./complete_streets.html'),
    controller: CompleteStreetsComponent,
    controllerAs: 'completeStreetsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/stationaccess/complete_streets/complete_streets.component.js